var _filter, _g, _g2, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "laptopGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ffffff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#f8faff",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "softGlow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 8,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "blur",
    in2: "SourceGraphic",
    operator: "over"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100, 180)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 130,
    rx: 12,
    fill: "url(#laptopGrad)",
    stroke: "#E0E7FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 180,
    height: 100,
    rx: 6,
    fill: "#E0E7FF",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 30 L130 45 V75 C130 95 100 110 100 110 C100 110 70 95 70 75 V45 L100 30 Z",
    fill: "#93A5FF",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 70 L98 76 L110 64",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20 130 L220 130 L210 145 L-10 145 Z",
    fill: "#E0E7FF",
    opacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(240, 80) rotate(-15) scale(0.7)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 200,
    height: 130,
    rx: 12,
    fill: "white",
    stroke: "#E0E7FF",
    strokeWidth: 2,
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 180,
    height: 100,
    rx: 6,
    fill: "#D0DAFF",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 40,
    width: 120,
    height: 10,
    rx: 5,
    fill: "#93A5FF",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 60,
    width: 80,
    height: 10,
    rx: 5,
    fill: "#93A5FF",
    opacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220 180 Q260 140 280 120",
    stroke: "#93A5FF",
    strokeWidth: 2,
    strokeDasharray: "6 6",
    opacity: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 120,
    r: 4,
    fill: "#93A5FF",
    opacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopSecurity);
export default __webpack_public_path__ + "static/media/laptop_security.8bccac60b503c9b1f81b6e478758f53d.svg";
export { ForwardRef as ReactComponent };